<template>

  <v-dialog v-model="dialogPreview" persistent fullscreen hide-overlay class="maxWidth"
    transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">

      <v-btn class="stylepreviewbtn" v-bind="attrs" v-on="on" text>
        <!--v-icon class="mr-2">mdi-eye-outline</v-icon-->{{$t('preview')}}
      </v-btn>

    </template>
    <v-card class="mx-auto">
      <v-toolbar>
        <h2 class="memexStoryTitle ml-2">{{cache.storyTitle}}</h2>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="red darken-3" icon @click="dialogPreview = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container pt-0 mt-0 mx-0 px-0>

        <singleStoryMapView :marker="cache.marker" :storyTitle="cache.storyTitle" />

        <v-carousel height="auto" :show-arrows="false">
          <v-carousel-item>
            <v-row>

              <mediaFileStory class="previewCoverImage"
                v-if="this.tempMediaOnIndexDB.imageOb&&this.tempMediaOnIndexDB.imageObj.media.formats.coverImageCenter!=null||this.tempMediaOnIndexDB.imageObj.media.formats.small!=null"
                :mediaUrl=" this.tempMediaOnIndexDB.imageObj.media.formats.coverImageCenter? strapiUrl +'/uploads/'+ this.tempMediaOnIndexDB.imageObj.media.formats.coverImageCenter.hash + this.tempMediaOnIndexDB.imageObj.media.formats.coverImageCenter.ext:strapiUrl +'/uploads/'+ this.tempMediaOnIndexDB.imageObj.media.formats.small.hash + this.tempMediaOnIndexDB.imageObj.media.formats.small.ext"
                :type="'image'" :isLocal="false" :isThumbnail="true" />
              <v-img v-else :src="require('@/assets/placeholder.png')" class="previewCoverImage" />
              <!--audioplayer :audioFiles="cache.audioFiles"/>
            <videoplayer :headertitle="cache.storyTitle"
              :source="previewvideourl"/-->
            </v-row>
          </v-carousel-item>

          <!---->
          <template v-if="typeof(tempMediaOnIndexDB.images)!='undefined'&&tempMediaOnIndexDB.images.length>0">
            <v-carousel-item v-for="singleKGimages in imagesSource" :key="singleKGimages.url+singleKGimages.name">
              <v-img :src="singleKGimages.url" />
            </v-carousel-item>
            <!---->
          </template>

          <v-carousel-item v-for="singleKGimages in cache.KGArrayImg" :key="singleKGimages.id+singleKGimages.image">
            <template>
              <v-img :contain="true" :src="singleKGimages.image" />
            </template>
          </v-carousel-item>
        </v-carousel>

        <v-col cols="12">
          <div style="text-align:right">
            <template
              v-if="typeof(tempMediaOnIndexDB.attachments)!='undefined'&&tempMediaOnIndexDB.attachments.length>0">
              <v-btn class="ml-1 text--primary" color="secondaryVariant" small left fab
                @click.stop="dialogattachments = true">
                <v-icon style="transform:rotate(270deg);">mdi-attachment</v-icon>
              </v-btn>
              <v-dialog v-model="dialogattachments" :fullscreen="true">
                <v-card>
                  <v-container class="pt-0 pb-0">
                    <v-row>
                      <v-col cols=10>
                        <h2 class="memexStoryTitle ml-2">{{cache.storyTitle}}</h2>
                      </v-col>
                      <v-col cols=2>
                        <v-btn color="red darken-3" text @click="dialogattachments = false" :icon="true">
                          <i class="big mdi mdi-close"></i>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-for="attachment in attachmentSource" :key="attachment.title" justify="end">
                      <v-col cols=12>
                        <a :href="attachment.url" download><span class="memexStoryTitle">{{attachment.name}}</span></a>
                      </v-col>

                    </v-row>
                  </v-container>
                  <v-card-title class="headline">
                  </v-card-title>
                  <v-card-text>
                    <!--mediaFileStory v-for="singleattachment in tempMediaOnIndexDB.attachments" :key="singleattachment.id"
                    :mediaUrl="apiStrapi + singleattachment.media.url.replace(/ /g, '%20')" type="attachment"
                    :mediaFileTitle="singleattachment.title" :storyTitle="tempMediaOnIndexDB.title" :isLocal="false" /-->
                  </v-card-text>
                </v-card>
              </v-dialog>
            </template>

            <template v-if="this.tempMediaOnIndexDB.videoTitle!=null&&this.tempMediaOnIndexDB.videoTitle!=''">
              <v-btn class="ml-1 text--primary" color="secondaryVariant" small right fab @click.stop="openVideo">
                <v-icon>mdi-play-box-multiple-outline</v-icon>
              </v-btn>
              <v-dialog v-model="dialogvideo" :fullscreen="true">
                <v-card>
                  <v-container class="pt-0 pb-0">
                    <v-row>
                      <v-col cols=10>
                        <h2 class="memexStoryTitle ml-2">{{cache.storyTitle}}</h2>
                      </v-col>
                      <v-col cols=2>
                        <v-btn color="red darken-3" text @click="dialogvideo = false" :icon="true">
                          <i class="big mdi mdi-close"></i>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row justify="end">
                      <v-col cols=12>
                        {{tempMediaOnIndexDB.videoTitle}}
                        <video-player refs="videoplayer">
                          <source :src="previewvideourl" />
                        </video-player>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-card-title class="headline">
                  </v-card-title>
                  <v-card-text>
                    <!--mediaFileStory :mediaUrl="apiStrapi + tempMediaOnIndexDB.video.media.url.replace(/ /g, '%20')"
                    type="video" :mediaFileTitle="tempMediaOnIndexDB.video.title" :storyTitle="tempMediaOnIndexDB.title"
                    :isLocal="false" /-->
                  </v-card-text>
                </v-card>
              </v-dialog>
            </template>

            <template>
              <v-btn v-if="typeof(tempMediaOnIndexDB.audios)!='undefined'&&tempMediaOnIndexDB.audios.length>0"
                class="ml-1 text--primary" color="secondaryVariant" small left fab @click.stop="openAudio">
                <v-icon>mdi-music-note-outline</v-icon>
              </v-btn>
              <v-dialog v-model="dialogaudio" :fullscreen="true">
                <v-card>
                  <v-container class="pt-0 pb-0">
                    <v-row>
                      <v-col cols=10>
                        <h2 class="memexStoryTitle ml-2">{{cache.storyTitle}}</h2>
                      </v-col>
                      <v-col cols=2>
                        <v-btn color="red darken-3" text @click="dialogaudio = false" :icon="true">
                          <i class="big mdi mdi-close"></i>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <span v-for="singlefileaudio in audioSource" :key="singlefileaudio.name">
                      <v-card-title class="headline">
                      </v-card-title>
                      <v-card-text>
                        {{singlefileaudio.name}}
                        <audio-player>
                          <source :src="singlefileaudio.url" />
                        </audio-player>
                      </v-card-text>
                    </span>
                  </v-container>
                  <v-card-title class="headline">
                  </v-card-title>
                  <v-card-text v-if="tempMediaOnIndexDB.audios!=[]">

                    <!--mediaFileStory v-for="singleAudio in tempMediaOnIndexDB.audios" :key="singleAudio.id"
                    :mediaUrl="apiStrapi + singleAudio.media.url.replace(/ /g, '%20')" type="audio"
                    :mediaFileTitle="singleAudio.title" :storyTitle="tempMediaOnIndexDB.title" :isLocal="false" /-->
                  </v-card-text>
                </v-card>
              </v-dialog>
            </template>
          </div>
        </v-col>



        <v-col cols=12>
          <p v-for="singleAudio in cache.audioFile" :key="singleAudio.name">{{singleAudio.name}}</p>
          <div class="contentpreview" v-for="element in cache.content" :key="element.content" v-html="element.data">
          </div>
        </v-col>


        <template v-if="cache.tags && cache.tags.length>0">
              <v-col cols="12" v-if="cache.tags.length>0">
                <span v-for="tag in cache.tags" :key="tag.id">
                  <v-chip v-if="tag.id" class="mr-2 mb-1">{{$t(storyMapTag[tag.id])}}</v-chip>
                  <v-chip v-else class="mr-2 mb-1">{{$t(storyMapTag[tag])}}</v-chip>
                </span>
              </v-col>
          </template>
        <v-footer v-if="typeof cache.content!='undefined'&&cache.content.length>1" class="grey lighten-3 px-5 pt-0">
          <v-container>
            <v-row>
              <v-col v-if="cache.content.length>1" cols="12" style="mb-5"><strong>{{ $t("Sources")}}</strong></v-col>
              <v-col cols="12" class="px-3 mx-3 pt-0 pb-0 mt-0 mb-0">
                <ol>
                  <span v-for="(element,index) in cache.content" :key="index">
                    <li v-if="element.type=='quote'">
                      <a :href="element.url">{{element.url}} </a>
                    </li>
                  </span>
                </ol>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>

      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
//component for the preview of a story being created / edited
import dialogMixin from "vue-dialog-mixin"
import { videoPlayer } from 'vue-md-player'

import {
    audioPlayer
} from 'vue-md-player'
import mediaFileStory from "@/components/mediaFileStory";
//import singleStoryMapView from "@/components/createOrEditStory/mapPreview";
import singleStoryMapView from "@/components/singleStoryMapView";
//import buttonFontSize from "@/components/buttonFontSize";
//import audioplayer from "@/components/audioplayer";
//import videoplayer from "@/components/videoplayer";
//import 'vue-md-player/dist/vue-md-player.css'

export default {
  name:"Preview",
    mixins: [dialogMixin],

    data () {
      return {
        strapiUrl: process.env.VUE_APP_ROOT_STRAPI,
        attachmentSource:[],
        audioSource:[],
        imagesSource:[],
        dialogaudio:false,
        dialogvideo:false,
        isDialogMediaPlayerClose:null,
        dialogattachments:false,
        apiUrl: process.env.VUE_APP_ROOT_API,
        cache:{},
        dialogPreview: false,
        notifications: false,
        sound: true,
        widgets: false,
        previewCoverImageUrl:null,
        previewvideourl:null,
        allTags:[],
        storyMapTag:[]
      }
    },
    components: {
      singleStoryMapView,
//      buttonFontSize,
        audioPlayer,
      videoPlayer,
      mediaFileStory
    },
      async mounted() {
//loadimages
        if (this.tempMediaOnIndexDB.images.length > 0) {
            this.tempMediaOnIndexDB.images.forEach(async (singleImageFile) => {
                await this.getFileFromIndexDB(singleImageFile.title).then(async response => {
                    var url = await window.URL.createObjectURL(response[0].blob)
                    this.imagesSource.push({
                        'name': singleImageFile.title,
                        'url': url
                    })
                })
            })
        }
        //load audio
        if (this.tempMediaOnIndexDB.audios.length > 0) {
            this.tempMediaOnIndexDB.audios.forEach(async (singleAudioFile) => {
                await this.getFileFromIndexDB(singleAudioFile.title).then(async response => {
                    var url = await window.URL.createObjectURL(response[0].blob)
                    this.audioSource.push({
                        'name': singleAudioFile.title,
                        'url': url
                    })
                })
            })
        }
        //load attachments
        if (this.tempMediaOnIndexDB.attachments.length > 0) {
            this.tempMediaOnIndexDB.attachments.forEach(async (singleAttachmentFile) => {
                await this.getFileFromIndexDB(singleAttachmentFile.title).then(async response => {
                    var url = await window.URL.createObjectURL(response[0].blob)
                    this.attachmentSource.push({
                        'name': singleAttachmentFile.title,
                        'url': url
                    })
                })
            })
        }
//load video
        if (this.tempMediaOnIndexDB.videoTitle!=null&&this.tempMediaOnIndexDB.videoTitle!=""){
            await this.getFileFromIndexDB(this.tempMediaOnIndexDB.videoTitle).then(response=>{
            var blobvideo = response[0].blob
        if (blobvideo.size!=0){
            this.previewvideourl = window.URL.createObjectURL(blobvideo)
        }else{
            this.previewvideourl = null
        }
      })
    }

        //mapping a list of tags
        this.storytagName=[]
        await this.retriveListOfTags();
        //retrieves the information of a story being created
        this.cache = this.$store.getters.getNewStories
  //if there is a cover image, create a temporary url to use for the preview
    if (this.tempMediaOnIndexDB.imageTitle!=null&&this.tempMediaOnIndexDB.imageTitle!=""){
      await this.getFileFromIndexDB(this.tempMediaOnIndexDB.imageTitle).then(response=>{
      var blobimage = response[0].blob
      if (blobimage.size!=0){
        this.previewCoverImageUrl = window.URL.createObjectURL(blobimage)
      }else{
        this.previewCoverImageUrl = null
      }
      })
    }
  },
    computed: {
//retrieves the font size for the content
      tempMediaOnIndexDB: {
        get: function() {
          return this.$store.state.tempMediaOnIndexDB
        },
        set: function(newValue) {
          this.$store.dispatch("setTempMediaOnIndexDB", newValue)
        }
      },
//retrieves the font size for the content
    currentFontSize:{
    get: function () {
        return this.$store.getters.getCurrentFontSize;
      }
    }
    },
  methods:{
    none(){
      return
    },
      openAudio() {
    this.$store.dispatch('setIsDialogMediaPlayerClosed',false).then(()=> this.dialogaudio = true)
  },
    openVideo() {
      this.$store.dispatch('setIsDialogMediaPlayerClosed',false).then(()=> this.dialogvideo = true)
    },
      closeVideo(){
      this.$store.dispatch('setIsDialogMediaPlayerClosed',true).then(()=> this.dialogvideo = false)
      },
      closeAudio(){
        this.$store.dispatch('setIsDialogMediaPlayerClosed',true).then(()=> this.dialogaudio = false)
      },
    //retrieves blob file from indexdb
    getFileFromIndexDB: function (name) {
      return this.$indexdb.mediaFiles.where("name").equalsIgnoreCase(name).toArray()
    },
//retrieves the list of all tags and creates an array id-name tag
      async retriveListOfTags() {
        try {
          this.$store.dispatch('setLoading', true)
          let completeurl = this.apiUrl + '/getTags'
          let tagsFromDB
          tagsFromDB = await this.getaxiosResponse(completeurl)
          this.allTags = tagsFromDB.data
          this.allTags.forEach(item => this.storyMapTag[item.id]=item.tag)
          this.$store.dispatch('setLoading', false)
        } catch (error) {
          console.log(error);
        }
      }
    }
}
</script>
<style>
.maxWidth{
  width: 700px;
 max-width: 700px;
 margin-left: auto;
 margin-right: auto;
}
.stylepreviewbtn{
  border: 2px solid #000000;
  border-radius: 999rem;
  padding: 10px;
}
.previewCoverImage{
width: 100%;
min-height:10vh
}
.contentpreview img{
width: 100%;
}
.upperborderrow{
height: 1px;
}
</style>